// extracted by mini-css-extract-plugin
export default {"body":"confirm-modal_body__goV4l","text":"confirm-modal_text__iOAwE","actions":"confirm-modal_actions__clhW5"};